export default __webpack_public_path__ + "static/tiempos-text-web-regular-f386c0d694f3aa2aa761b442bf1ee33c.woff";